import Application from "../../Application";

import PortalHomePresenter, {
  IPortalHomePresenter
} from "../presenter/PortalHomePresenter";

export default class ShowPortalInteractor {
  private application: Application;
  private output?: IPortalHomePresenter;

  constructor({ application, findResourceEntry }: any) {
    this.application = application;
  }

  execute() {
    this.output = PortalHomePresenter({
      application: this.application,
      initialState: {}
    });

    return this.output;
  }
}
